var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDigitalePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 199.32 156.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:none;}.cls-2{clip-path:url(#clippath-1);}.cls-10{fill:#0069b4;}.cls-11{fill:#fff;}.cls-12{fill:url(#Neues_Verlaufsfeld_1);}.cls-3,.cls-8{stroke:#fff;stroke-linejoin:round;stroke-width:1.62px;}.cls-13{fill:url(#Neues_Verlaufsfeld_1-2);}.cls-4{stroke:url(#Neues_Verlaufsfeld_1-3);}.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;stroke-width:1.7px;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke-linecap:round;}.cls-5{stroke:url(#Neues_Verlaufsfeld_1-4);}.cls-6{stroke:url(#Neues_Verlaufsfeld_1-6);}.cls-7{stroke:url(#Neues_Verlaufsfeld_1-5);}.cls-9{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.07,0c-31.6,0-57.22,25.62-57.22,57.22s25.62,57.22,57.22,57.22,57.22-25.62,57.22-57.22S134.67,0,103.07,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Neues_Verlaufsfeld_1",
    x1: -192.08,
    y1: 511.17,
    x2: -191.08,
    y2: 511.17,
    gradientTransform: "translate(22028.93 58559.19) scale(114.45 -114.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fbdc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#355ca7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.54,38.44c-1.06-1.08-1.59-2.5-1.59-4.29s.52-3.2,1.57-4.27c1.05-1.06,2.42-1.6,4.11-1.6,1.09,0,2.06.24,2.92.71.86.47,1.54,1.15,2.04,2.04.5.89.75,1.93.75,3.11s-.25,2.23-.75,3.12c-.5.89-1.18,1.58-2.04,2.06-.86.48-1.83.73-2.92.73-1.67,0-3.03-.54-4.09-1.62m-3.84-17.4c-2.39,1.28-4.25,3.04-5.58,5.31-1.32,2.26-1.99,4.83-1.99,7.71s.66,5.46,1.97,7.75c1.31,2.29,3.15,4.07,5.53,5.36s5.08,1.93,8.13,1.93c1.22,0,2.48-.13,3.77-.4,1.29-.26,2.43-.65,3.41-1.15l-.74-2.11c-.93.48-1.97.85-3.1,1.09-1.14.24-2.25.36-3.34.36-2.6,0-4.9-.54-6.89-1.63-1.99-1.09-3.54-2.6-4.64-4.53-1.1-1.93-1.65-4.15-1.65-6.66s.56-4.69,1.67-6.62c1.11-1.93,2.68-3.44,4.69-4.51,2.02-1.08,4.34-1.61,6.96-1.61s4.91.52,6.93,1.55,3.58,2.48,4.69,4.33c1.11,1.86,1.67,4.01,1.67,6.44,0,2.07-.27,3.67-.82,4.8-.55,1.13-1.31,1.7-2.29,1.7-.56,0-1.01-.19-1.37-.58-.36-.38-.54-.98-.54-1.8v-11.87h-2.9v2.67c-.69-.92-1.56-1.62-2.6-2.09-1.05-.47-2.21-.71-3.51-.71-1.56,0-2.96.36-4.21,1.07-1.25.71-2.22,1.71-2.92,3-.7,1.29-1.05,2.73-1.05,4.33s.35,3.08,1.05,4.37c.7,1.29,1.67,2.29,2.92,3.01,1.25.73,2.65,1.09,4.21,1.09,1.4,0,2.64-.27,3.72-.81,1.08-.54,1.95-1.31,2.62-2.32.2,1.01.65,1.78,1.35,2.32.7.54,1.59.81,2.65.81,1.87,0,3.33-.8,4.38-2.41,1.05-1.6,1.57-3.81,1.57-6.62s-.66-5.32-1.99-7.51c-1.32-2.2-3.17-3.91-5.53-5.12-2.36-1.22-5.04-1.83-8.05-1.83s-5.81.64-8.2,1.91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Neues_Verlaufsfeld_1-2",
    x1: -188.49,
    y1: 518.9,
    x2: -187.49,
    y2: 518.9,
    gradientTransform: "translate(5976.87 16286.6) scale(31.32 -31.32)",
    xlinkHref: "#Neues_Verlaufsfeld_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Neues_Verlaufsfeld_1-3",
    x1: 8.81,
    y1: 129.01,
    x2: 199.32,
    y2: 129.01,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#Neues_Verlaufsfeld_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Neues_Verlaufsfeld_1-4",
    x1: 6.66,
    y1: 55.09,
    x2: 36.36,
    y2: 55.09,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#Neues_Verlaufsfeld_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Neues_Verlaufsfeld_1-5",
    x1: 0,
    y1: 64.32,
    x2: 23.7,
    y2: 64.32,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#Neues_Verlaufsfeld_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Neues_Verlaufsfeld_1-6",
    x1: 28.09,
    y1: 64.32,
    x2: 32.79,
    y2: 64.32,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#Neues_Verlaufsfeld_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m11.24,144.05h3.85c.73,0,1.37.12,1.91.38.54.25.99.59,1.34,1.03s.61.96.79,1.55.26,1.23.26,1.91c0,1.12-.17,2.15-.51,3.1-.34.95-.81,1.77-1.42,2.47-.61.69-1.32,1.24-2.15,1.63-.82.39-1.72.59-2.7.59h-3.85l2.48-12.65Zm1.66,11.22c.76,0,1.45-.17,2.06-.5.61-.33,1.13-.78,1.56-1.34.43-.56.76-1.21.99-1.95s.34-1.51.34-2.32c0-.53-.07-1.03-.2-1.48-.13-.45-.32-.84-.57-1.17-.25-.33-.57-.58-.95-.77-.38-.18-.82-.28-1.33-.28h-2.38l-1.92,9.8h2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m24.06,144.06h1.47l-2.47,12.63h-1.48l2.48-12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m35.4,155c-.6.61-1.2,1.05-1.81,1.34-.61.29-1.23.44-1.86.44s-1.19-.15-1.69-.44c-.5-.29-.93-.68-1.28-1.18-.35-.49-.62-1.06-.8-1.69-.19-.63-.28-1.3-.28-1.99,0-.96.18-1.89.55-2.8.37-.9.85-1.71,1.46-2.41.61-.71,1.3-1.27,2.09-1.69.79-.42,1.61-.63,2.46-.63,1.07,0,1.9.26,2.5.77.6.51,1,1.18,1.2,2l-1.29.85c-.19-.74-.52-1.28-.99-1.64-.48-.36-1.05-.53-1.73-.53s-1.26.17-1.84.53-1.08.81-1.52,1.37c-.43.56-.77,1.21-1.02,1.92-.25.72-.38,1.45-.38,2.18,0,.55.07,1.06.2,1.53.14.48.33.89.59,1.25.26.36.57.64.93.85.37.21.77.31,1.22.31.59,0,1.18-.16,1.78-.49.6-.33,1.2-.83,1.83-1.52l.34-1.73h-2.38l.25-1.21h3.61l-1.23,6.31h-1.25l.33-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m42.46,144.06h1.47l-2.47,12.63h-1.48l2.48-12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m50.56,145.47h-3.79l.28-1.43h9.05l-.28,1.43h-3.79l-2.2,11.22h-1.48l2.2-11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m61.42,144.05h1.26l2.02,12.65h-1.57l-.56-3.71h-4.56l-1.98,3.71h-1.57l6.97-12.65Zm1.08,7.7l-.8-5.84-3.16,5.84h3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m70.17,144.05h1.47l-2.2,11.22h6.11l-.28,1.42h-7.59l2.48-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m80.81,144.05h7.38l-.28,1.43h-5.9l-.8,4.1h5.13l-.26,1.34h-5.13l-.85,4.37h6.05l-.28,1.42h-7.52l2.48-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m92.95,156.82c-.85,0-1.63-.15-2.34-.45-.71-.3-1.31-.75-1.83-1.33l.97-1.35c.12.2.29.4.51.61.22.2.48.38.79.54.31.16.64.29,1.02.39.37.1.77.15,1.2.15.89,0,1.58-.2,2.09-.6.51-.4.76-.95.76-1.67,0-.28-.06-.53-.19-.74-.13-.21-.31-.39-.54-.55-.24-.16-.52-.3-.86-.42-.34-.12-.72-.24-1.15-.37-.45-.13-.85-.27-1.2-.43-.35-.15-.64-.33-.88-.54-.24-.21-.42-.45-.55-.73s-.19-.61-.19-.99c0-.69.13-1.3.38-1.84.25-.54.6-1,1.03-1.37.44-.37.95-.66,1.53-.86.58-.2,1.2-.3,1.86-.3.74,0,1.39.13,1.95.39.56.26,1.03.61,1.41,1.05l-.93,1.3c-.09-.17-.22-.33-.39-.48-.18-.15-.38-.29-.62-.42-.24-.12-.51-.23-.79-.3s-.6-.12-.93-.12c-.99,0-1.72.23-2.18.69s-.69,1.04-.69,1.75c0,.26.05.48.16.67.1.18.26.34.47.48.21.14.46.26.77.37.31.11.67.22,1.08.33.47.13.9.28,1.28.44s.71.35.98.58.48.49.62.8c.15.31.22.68.22,1.12,0,.71-.13,1.33-.39,1.86s-.6.96-1.04,1.31-.95.6-1.52.77-1.2.26-1.85.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m108.43,144.05h4.62c.42,0,.79.1,1.11.29.33.19.61.44.84.75.23.31.4.67.52,1.07.12.4.18.82.18,1.25,0,.57-.11,1.14-.34,1.71-.22.57-.52,1.08-.9,1.53s-.82.82-1.32,1.1c-.5.28-1.04.42-1.61.42h-3.23l-.88,4.54h-1.48l2.48-12.65Zm3.31,6.68c.33,0,.64-.09.94-.27.3-.18.56-.42.79-.71s.4-.64.53-1.02c.13-.39.2-.78.2-1.18,0-.61-.14-1.1-.43-1.49-.29-.39-.65-.58-1.1-.58h-3.05l-1.03,5.25h3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.78,156.78c-.66,0-1.24-.15-1.75-.44s-.95-.68-1.29-1.16c-.35-.48-.62-1.04-.79-1.67-.18-.63-.27-1.28-.27-1.96,0-.96.19-1.9.56-2.81.37-.91.87-1.73,1.48-2.44s1.33-1.28,2.13-1.71c.8-.43,1.63-.64,2.48-.64.66,0,1.24.15,1.75.45.51.3.93.69,1.28,1.18.34.49.61,1.05.79,1.67.18.63.27,1.28.27,1.96,0,.96-.18,1.9-.55,2.81-.37.91-.86,1.72-1.48,2.42-.62.71-1.32,1.27-2.12,1.7-.8.43-1.62.64-2.47.64Zm.29-1.44c.67,0,1.29-.18,1.88-.54s1.1-.83,1.53-1.41.77-1.22,1.02-1.93.38-1.42.38-2.12c0-.52-.06-1.02-.19-1.5s-.31-.89-.56-1.25c-.25-.36-.55-.64-.91-.86-.36-.21-.77-.32-1.23-.32-.68,0-1.31.18-1.89.53-.58.36-1.1.82-1.53,1.4-.44.58-.78,1.22-1.03,1.93-.25.71-.38,1.43-.38,2.14,0,.52.06,1.02.19,1.5.12.47.31.89.56,1.25s.55.64.91.85c.36.21.78.32,1.25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m134.2,156.82c-.85,0-1.63-.15-2.34-.45-.71-.3-1.31-.75-1.83-1.33l.97-1.35c.12.2.29.4.51.61.22.2.48.38.79.54.31.16.64.29,1.02.39.37.1.77.15,1.2.15.89,0,1.58-.2,2.09-.6.51-.4.76-.95.76-1.67,0-.28-.06-.53-.19-.74-.13-.21-.31-.39-.54-.55-.24-.16-.52-.3-.86-.42-.34-.12-.72-.24-1.15-.37-.45-.13-.85-.27-1.2-.43-.35-.15-.64-.33-.88-.54-.24-.21-.42-.45-.55-.73-.12-.28-.19-.61-.19-.99,0-.69.13-1.3.38-1.84.25-.54.6-1,1.03-1.37.44-.37.95-.66,1.53-.86.58-.2,1.2-.3,1.86-.3.74,0,1.39.13,1.95.39.56.26,1.03.61,1.41,1.05l-.93,1.3c-.09-.17-.22-.33-.39-.48-.18-.15-.38-.29-.62-.42-.24-.12-.51-.23-.79-.3-.29-.08-.6-.12-.93-.12-1,0-1.72.23-2.18.69s-.69,1.04-.69,1.75c0,.26.05.48.16.67.1.18.26.34.47.48.21.14.46.26.77.37.31.11.67.22,1.08.33.47.13.9.28,1.28.44.38.16.71.35.97.58s.48.49.62.8c.15.31.22.68.22,1.12,0,.71-.13,1.33-.39,1.86s-.6.96-1.04,1.31c-.44.34-.95.6-1.52.77s-1.2.26-1.85.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m146.53,145.47h-3.79l.28-1.43h9.05l-.28,1.43h-3.79l-2.2,11.22h-1.47l2.2-11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m155.2,144.05h7.31l-.28,1.43h-5.83l-.82,4.22h4.9l-.26,1.34h-4.9l-1.11,5.67h-1.48l2.48-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m168.33,144.05h1.26l2.02,12.65h-1.57l-.56-3.71h-4.56l-1.98,3.71h-1.57l6.97-12.65Zm1.08,7.7l-.8-5.84-3.16,5.84h3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m178.57,156.8c-.64,0-1.22-.15-1.73-.45-.51-.3-.93-.7-1.28-1.2-.34-.5-.61-1.07-.79-1.71-.18-.64-.27-1.3-.27-1.98,0-.87.17-1.75.5-2.64.33-.89.79-1.7,1.38-2.41.59-.72,1.29-1.3,2.11-1.75.81-.45,1.7-.68,2.66-.68.49,0,.94.07,1.33.21.4.14.75.33,1.06.57.31.24.56.53.75.87.2.34.34.71.44,1.11l-1.33.82c-.09-.4-.22-.74-.39-1.02-.17-.27-.38-.49-.62-.66-.23-.17-.49-.29-.77-.36-.28-.07-.55-.11-.83-.11-.71,0-1.36.18-1.95.55s-1.1.84-1.52,1.42c-.43.58-.76,1.21-.99,1.92-.24.7-.35,1.39-.35,2.07,0,.53.07,1.04.2,1.53.13.49.32.91.57,1.27.25.36.56.65.92.86.36.21.77.32,1.23.32.28,0,.59-.04.91-.12s.64-.22.95-.4c.31-.18.61-.42.91-.7.29-.28.56-.61.79-1.01l1.08.73c-.26.47-.59.89-.98,1.26s-.81.67-1.26.92c-.45.25-.91.44-1.39.57-.47.13-.93.2-1.35.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m188.75,144.05h1.47l-1.07,5.47h5.98l1.06-5.47h1.48l-2.47,12.65h-1.48l1.13-5.75h-5.98l-1.13,5.75h-1.48l2.48-12.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 45.84,
    width: 114.45,
    height: 114.45
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "56.63 62.66 140.11 32.43 119.96 101.52 90.91 76.17 56.63 62.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.61,90.01l-11.52,7.2v-24.65m20.19,2.8l27.3-31.41-38.99,24.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m88.8,54.68c11.36,0,20.58-9.21,20.58-20.58s-9.21-20.58-20.58-20.58-20.58,9.21-20.58,20.58,9.21,20.58,20.58,20.58"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 73.14,
    y: 19.13,
    width: 31.32,
    height: 29.96
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 9.66,
    y1: 129.01,
    x2: 198.47,
    y2: 129.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7.51,
    y1: 55.09,
    x2: 35.51,
    y2: 55.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 0.85,
    y1: 64.32,
    x2: 22.85,
    y2: 64.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 28.94,
    y1: 64.32,
    x2: 31.94,
    y2: 64.32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalePost);
export default __webpack_public_path__ + "static/media/icon_digitale_post.888d909eb167ba346efa3664393a7b6a.svg";
export { ForwardRef as ReactComponent };